var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refresh simple-click-hover",on:{"click":_vm.refresh}},[_c('i',{staticClass:"el-icon-refresh"}),_c('span',[_vm._v("换一换")])])
}
var staticRenderFns = []

export { render, staticRenderFns }